function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  fill: "none",
  stroke: "#EE777B",
  strokeWidth: 5.5,
  strokeMiterlimit: 10,
  cx: 82.75,
  cy: 82.75,
  r: 80
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#EE777B",
  d: "M88.406,82.75l21.416-21.416c1.563-1.562,1.563-4.095,0-5.656c-1.562-1.563-4.095-1.563-5.656,0 L82.75,77.093L61.335,55.678c-1.563-1.563-4.096-1.563-5.657,0c-1.563,1.562-1.563,4.094,0,5.656L77.094,82.75l-21.416,21.416 c-1.563,1.563-1.563,4.095,0,5.656c0.781,0.781,1.804,1.172,2.828,1.172c1.023,0,2.047-0.391,2.829-1.172L82.75,88.407 l21.416,21.415c0.78,0.781,1.804,1.172,2.827,1.172c1.024,0,2.049-0.391,2.829-1.172c1.563-1.562,1.563-4.094,0-5.656L88.406,82.75z "
});

var SvgDaFare = function SvgDaFare(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 167,
    height: 166,
    viewBox: "-0.948 -0.343 167 166",
    enableBackground: "new -0.948 -0.343 167 166",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDaFare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/da_fare.ccc58adc.svg";
export { ForwardRef as ReactComponent };